import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11d69d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-name-box" }
const _hoisted_2 = { class: "operat-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_form, {
      ref: "form",
      "label-width": "90px",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ui_form_item, {
          label: "商品名称",
          required: true,
          data: _ctx.formData.name,
          rule: _ctx.validateName
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
              maxlength: "20",
              placeholder: "请输入商品名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["data", "rule"]),
        _createVNode(_component_ui_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                onClick: _ctx.submit,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_loading, _ctx.submitLoading]
              ]),
              _createVNode(_component_el_link, {
                onClick: _ctx.close,
                underline: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}